import { render, staticRenderFns } from "./device-replace-choose.vue?vue&type=template&id=cde39974&scoped=true"
import script from "./device-replace-choose.vue?vue&type=script&lang=ts"
export * from "./device-replace-choose.vue?vue&type=script&lang=ts"
import style0 from "./device-replace-choose.vue?vue&type=style&index=0&id=cde39974&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cde39974",
  null
  
)

export default component.exports